import {createAction} from 'redux-actions'

export const fetchOneData = createAction('CENTRAL_STATIONS/ONE/FETCH', (centralStationId) => ({centralStationId}))
export const receiveOneData = createAction('CENTRAL_STATIONS/ONE/RECEIVE')
export const fetchError = createAction('CENTRAL_STATIONS/ONE/ERROR')